// extracted by mini-css-extract-plugin
module.exports = {"GlobalPreferenceSettings":"GlobalPreferenceSettings___3fHMg","pageTitle":"pageTitle___1uYt9"};